module.exports = __webpack_public_path__ + "img/picture.8654bf39.svg";